import ContentLoader from "react-content-loader";

const LabelSkeleton = (props) => (
  <ContentLoader
    speed={2}
    width={91}
    height={19}
    viewBox="0 0 91 19"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <path d="M 0 0 h 91 v 19 H 0 z" />
  </ContentLoader>
);

export default LabelSkeleton;
